import React from "react";
import DeviceFilter from "./device-filter/DeviceFilter";
import ClientFilters from "./client-filter/ClientFilter";
import { useLocation } from "react-router-dom";
import OrganizationFilter from "./organization-filter/OrganizationFilter";
import RoleFilter from "./role-filter/RoleFilter";
import ClientKitFilters from "./client-kit-filter/ClientKitFilter";
import SubjectFilter from "./subject-filter/SubjectFilter";

type Props = {};

const Filters = (props: Props) => {
  const location = useLocation();
  const pathname = location.pathname;

  if (pathname.includes("devices")) {
    return <DeviceFilter />;
  } else if (pathname.includes("kits")) {
    return <ClientKitFilters />;
  } else if (pathname.includes("clients")) {
    return <ClientFilters />;
  } else if (pathname.includes("org")) {
    return <OrganizationFilter />;
  } else if (pathname.includes("roles")) {
    return <RoleFilter />;
  } else if (pathname.includes("subjects")) {
    return <SubjectFilter />;
  }

  return null;
};

export default Filters;
